module.exports = __webpack_public_path__ + "img/logo.3e600f62.png";